<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TdkVxk/images/cover.jpg?1690317075997" alt="This image is the cover for the book Battle of Leyte Gulf, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle of Leyte Gulf, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <b>A photographic history of World War II’s largest naval battle, in which the Japanese and Americans squared off in the Philippines.</b><br/><br/>On October 20, 1944, the U.S. Sixth Army began landing on Leyte’s eastern coast, supported by the U.S. Navy's 3rd and 7th fleets, which were assisted by ships from the Royal Australian Navy. The Japanese were aware that the Americans were poised to attack the Philippines and planned to draw the American warships into one last great battle to try and stave off the otherwise inevitable defeat. Over the course of the following three days, the two naval forces had four separate engagements. Involving more than 360 ships and 200,000 naval personnel, the battle was the greatest naval encounter of World War II—and possibly the largest naval battle in history.<br/><br/>The result was disastrous for the Japanese, who lost three battleships, four aircraft carriers, ten cruisers, and eleven destroyers, along with almost 300 aircraft—the greatest loss of ships and crew the Japanese had ever experienced. In <i>Battle of Leyte Gulf</i>, the actions of the warships as well as the accompanying amphibious landings on Leyte by the U.S. Sixth Army are vividly revealed through a dramatic collection of photographs depicting the ships, sailors, airmen, and soldiers who made history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Grehan, Alexander Nicoll
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?752f148a